import React from "react";
export interface Props {setData: Function,title : string, type1 : string, type2 : string, name : string, value : string}
export const TypeRadioBox:React.FC<Props> = ({setData,title,type1,type2,name,value}) => {
    const handleChange = (e:any) =>{
        setData((prev : any)=>({...prev, [name] : e.target.value}))
    } 
    return(
        <>
        <tr>
            <th>{title}</th>
            <td className="toggleBtnBox">
                <div>
                    <div>
                        <input type="radio" value={type1} name={name} id="report_type1" onChange={handleChange} checked={value===type1?true:false}/>
                        <label htmlFor="report_type1">{type1}</label>
                    </div>
                    <div>
                        <input type="radio" value={type2} name={name} id="report_type2" onChange={handleChange} checked={value===type2?true:false}/>
                        <label htmlFor="report_type2">{type2}</label>
                    </div>
                </div>
                {/* <!-- toggleBox Fin --> */}
            </td>
        </tr>
        </>
    )
}